import React from 'react';
import * as C from "../componentsM/index";
import leadershipImage from "../assets/leadership7-100x100.png";
import rumaisaImage from "../assets/Rumaisa_Kidwai_Picture_for_website.jpg";
import mahjabeenImage from "../assets/Mahjabeen_rafay_-_Picture.jpg";
import shannonImage from "../assets/Shannon_picture_for_website.jpeg";
import sadaizafar from "../assets/1715583252707.jpeg"
import shahrukhkhan from "../assets/sirshahruckkhan.jpg"
// import teamImage3 from "/team/3.jpg";
// import teamImage5 from "/team/5.jpg";

import { FaLinkedin } from "react-icons/fa";

const SchoolLeadershipTeam = () => {

    const data = new getData();

    return (
        <>

            <C.Hero title={"SCHOOL LEADERSHIP TEAM"} image={"/hero/6.jpg"} />


            <section className='p-4 md:p-24'>

                {data.team.map(v => <div key={v} className='mb-8 md:mb-20'>

                    <figure className="w-[15rem] h-[15rem] mx-auto overflow-hidden rounded-full border-4 border-gray-300">
                        <img
                            className="w-full h-full object-cover"
                            src={v.image}
                            alt={`${v.name}'s profile`}
                        />

                    </figure>

                    <h1 className='font-semibold text-2xl mt-8 text-center'>{v.name}</h1>
                    <h6 className='my-2 text-xl text-center'>{v.title}</h6>
                    <div className=' flex justify-center '  
                    ><FaLinkedin className = "cursor-pointer"size={50} onClick={() => v.link && window.open(v.link, "_blank")} color="#0076b4"/></div>

                    <p className='my-2 text-xl text-center'>{v.about}</p>


                </div>)}

            </section>

        </>
    )
}


export default SchoolLeadershipTeam




class getData {

    team = [
        {
            image: leadershipImage,
            name: "Taymur Mirza",
            title: "Head of  School",
            about: "My philosophy of education is similar to that of the International Baccalaureate Organisation (IBO). It is about building a global community, about social justice, about peace, “about learning to live together”. In my opinion this shared moral and social purpose of education embodies in it the many other purposes of education including the end of making money for a better family life. Fortunately at the time of founding The International School in 1996, the IBO Middle Years Programme (MYP) for students aged 11 to 16 years and the High School Diploma Programme for students aged 16 to 18 years was at offer for internationally minded schools like The International Schools. My team and I were able, by October of that year, to be authorised by IBO to offer the MYP. The process of convincing IBO of our commitment and readiness was intensive but successful. Subsequently in due course of time we were authorised for the IB Diploma and registered with Cambridge International Examination and Edexcel International (2004). Since then to now we are the first and only IB World School in Pakistan.I have experienced the role of an IB Assistant Examiner (4651) for IB Mathematical Studies (1999 to today); IB MYP Mathematics Guide Writer (1999); IB MYP Authorisation Visit Team Member (India – 1999, Thailand – 2007), IB MYP Homo Faber Presenter (2000), IB MYP Mathematics Workshop leader (2000), Five-Year Diploma Evaluation Review Team Member (2006), DP Authorisation Visit Trainee (2006), presenter at the IBAP Annual Conference (2006) and CIS school evaluation team member."
            ,link: 'https://www.linkedin.com/in/taymur-mirza-63a369?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'

        },
        {
            image: rumaisaImage,
            name: "RUMAISA KIDWAI",
            title: "PRIMARY YEARS PROGRAMME COORDINATOR",
            about: `I am an experienced and dedicated educator with over 10 years of teaching experience in
the International Baccalaureate (IB) framework. Throughout my career, I have had the
privilege of teaching across all grade levels, which has allowed me to develop expertise in
fostering an inquiry-based learning environment that empowers students to take ownership
of their learning journey.

Currently, I serve as the PYP Coordinator and PYP Exhibition Coordinator at The
International School, where I work closely with faculty and students to cultivate an
environment that promotes curiosity, critical thinking, and collaboration. Having previously
worked as a Language Coordinator, I bring a comprehensive understanding of the holistic
nature of the IB curriculum.

I am deeply passionate about the power of inquiry in shaping both students' academic and
personal development. I specialize in guiding teachers to implement the PYP curriculum
through an inquiry-driven approach, ensuring that student agency remains at the core of
every learning experience. My vision is to inspire a culture of lifelong learning, where
students are not only knowledgeable but also equipped with the skills and confidence to
navigate an ever-changing world.

My commitment to excellence in teaching and learning continues to have a positive impact
on our school community`,
link: "https://www.linkedin.com/in/rumaisa-kidwai-b15935255/"

        },
        {
            image: sadaizafar,
            name: "SAADIA ZAFAR",
            title: "MIDDLE YEARS PROGRAMME COORDINATOR",
            about: `At the core of our institution lies an unwavering commitment to International Baccalaureate (IB) education, where I have the honor of leading the International Baccalaureate Middle Years Program (IB MYP) with steadfast dedication. My mission is to cultivate a culture that harnesses educational technology to forge a promising developmental path for our learners, while concurrently empowering them to become capable and compassionate young leaders.

My goal is to shine a team of professional educators who are devoted to nurturing caring and principled individuals prepared to make positive contributions to the world, with an ability to take risks and make decisions, most suitable to certain and uncertain situations. As the Inclusive Education Coordinator, I am a staunch advocate for providing IB education to all students. I oversee initiatives that ensure each student receives the support they need to succeed.

In my capacity as an Examiner for Integrated Humanities, I bring a practitioner's perspective to this domain within our school. My focus is on delivering a comprehensive and enriching educational experience, which is of paramount importance in enhancing the assessment experience for our learners.`,
            link: 'https://www.linkedin.com/in/saadia-zafar-1074b4294?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'

        },
        {
            image: mahjabeenImage,
            name: "MAHJABEEN RAFAY",
            title: "DIPLOMA YEARS PROGRAMME COORDINATOR",
            about: `I am excited to be part of The International School (TIS) as the Diploma Programme Coordinator. With a passion for guiding students to become thoughtful,
resilient, and globally-conscious individuals, I am committed to upholding the values of academic excellence, integrity, and global citizenship that the IB
Diploma Programme represents.

With extensive experience in both academia and the corporate sector, I have spent many years helping students navigate their educational journeys and
achieve their full potential. Prior to my career in education, I gained invaluable experience in the advertising and banking sectors, where I developed strategic
thinking, leadership, and communication skills. This combination of corporate and academic experience allows me to bring a practical, well-rounded
approach to my work in education.

I have been actively involved in the IB framework as an educator for several years, during which time I have witnessed its transformative power. In addition,
I have been an IB parent for over a decade, which has provided me with a unique, dual perspective on the framework’s ability to nurture critical thinking,
creativity, and global awareness. I firmly believe in the IB approach, both as an educationist and a parent, because I have seen its positive impact on students’
academic and personal growth.

“Education is the most powerful weapon which you can use to change the world.” — Nelson Mandela

At TIS, as Pakistan’s first IB World School, we pride ourselves on being a pioneering institution that aligns closely with my own educational values. I hold
an MPhil in Cultural Studies and an MBA, which have equipped me with a broad understanding of culture, leadership, and management. These
qualifications, combined with my professional and personal experience, allow me to bring a well-rounded and holistic approach to my role as Diploma
Programme Coordinator.

The IB Diploma Programme is a critical foundation for students as they transition to higher education. Its rigorous curriculum cultivates critical thinking,
independent research, and global awareness, preparing students to succeed at top universities worldwide. TIS students consistently achieve impressive
university acceptance rates, with many gaining entry to some of the best institutions globally. I am excited to support and contribute to a programme that
opens up such opportunities for our students. I look forward to working collaboratively with the TIS community to ensure our students’ continued success`
,      link: 'https://www.linkedin.com/in/mahjabeenrafay?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
    
},
        {
            image: shannonImage,
            name: "SHANNON ERIC",
            title: "REGISTRAR",
            about: `I joined The International School (TIS) in 2024 as a Social Media Assistant while
pursuing my university studies. After two months, I was promoted to Registrar, a
role that has allowed me to contribute to the school's operations in a more
impactful way. My journey reflects my passion for growth, both personally and
professionally, and my commitment to supporting students, parents, and staff. I
take pride in fostering an organized and welcoming environment, ensuring smooth
communication and efficient processes that enhance the overall experience for
everyone at TIS.`,
link: 'https://www.linkedin.com/in/shannon-eric-573299303?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'

        },
        {
            image: shahrukhkhan,
            name: "SYED MUHAMMAD SHAH",
            title: "BUSINESS MANAGER",
            about: `I am a seasoned professional with over 18 years of experience in accounts and finance. Throughout my career, I have had the privilege of working across various industries, including manufacturing, retail, and services, where I have consistently demonstrated leadership, financial acumen, and strategic thinking.

My professional journey began in 2010 at TIS, where I started as a Senior Accountant. My dedication and skills quickly led to a promotion to Finance Manager, and I was honored to join the Senior Leadership Team. In this role, I had the opportunity to contribute significantly to the organization’s financial strategies and operations.

During my tenure at TIS, I also pursued and completed my MBA in Finance from the University of Karachi, which further enhanced my expertise and strategic perspective in the field.

Currently, I serve as the Business Manager at TIS, where I oversee multiple departments, including Finance, Human Resources, and Operations. My responsibilities span beyond financial oversight, as I work to ensure the smooth and efficient day-to-day management of the company while contributing to its broader strategic goals. I also focus on fostering collaboration across departments to drive organizational success.

With my extensive experience, I have built a reputation as a trusted leader in driving financial and operational excellence. My goal is always to align financial management with the company’s long-term objectives to help ensure its continued growth and success`
        },
    ]


}